import { apiClient } from './client';
import type { ApiResponse, PagedResult } from '@/types/api.types';
import type {
  CardClearingItemDto,
  CardClearingItemFilterDto,
  CardReceivablesAgeingRowDto,
} from '@/types/cardReconciliation.types';

export const cardClearingApi = {
  /** GET /api/v1/card-clearing-items — paginated list */
  getList: (filter?: CardClearingItemFilterDto) =>
    apiClient.get<ApiResponse<PagedResult<CardClearingItemDto>>>('/card-clearing-items', { params: filter }),

  /** GET /api/v1/card-clearing-items/ageing: unsettled card money per acquirer, aged */
  getAgeing: (asOf?: string) =>
    apiClient.get<ApiResponse<CardReceivablesAgeingRowDto[]>>('/card-clearing-items/ageing', { params: { asOf } }),
};
